const ENDPOINT = 'GETfeatureditems';
function getFeaturedItems(gateway, params) {
    return gateway.get(getFeaturedItems.endpoint, params);
}
getFeaturedItems.endpoint = ENDPOINT;

export { getFeaturedItems as default };
//# sourceMappingURL=getFeaturedItems.js.map
